import React, { useRef } from "react";
import AppContainer from "~v2/components/AppContainer/AppContainer";
import { Carousel } from "antd";
import FormSectionContainer from "~v2/components/FormSectionContainer/FormSectionContainer";

import OvernighGuestContext from "../../features/overnight-guest/context-view";
import PHResident from "../../features/overnight-guest/PHResidentView";
import NonPhResident from "../../features/overnight-guest/NonPHResidentView";
import OFW from "../../features/overnight-guest/OFWView";
import UnspecifiedResident from "../../features/overnight-guest/UnspecifiedResidentView";
import LengthOfStaySection from "../../features/overnight-guest/LengthOfStayView";
import ViewReportDatePicker from "../../components/ViewReportDatePicker/ViewReportDatePicker";
import {
  getDatesOfReports,
  getReportByDate,
} from "../../http-request/overnight-guest";
import CarouselButtons from "../../components/CarouselButtons/CarouselButtons";

const sections = [
  {
    index: 1,
    title: "philippine residents",
    headerColor: "RGB(135, 175, 221)",
    children: <PHResident />,
  },
  {
    index: 2,
    title: "non-philippine residents",
    headerColor: "RGB(209, 194, 138)",
    children: <NonPhResident />,
  },
  {
    index: 3,
    title: "overseas filipinos",
    headerColor: "RGB(158, 213, 165)",
    children: <OFW />,
  },
  {
    index: 4,
    title: "other and unspecified residence",
    headerColor: "RGB(201, 159, 213)",
    children: <UnspecifiedResident />,
  },
  {
    index: 5,
    title: "Part II: Occupancy and length of stay",
    headerColor: "RGB(209, 194, 138)",
    children: <LengthOfStaySection />,
  },
];

const OvernightGuestViewPage = () => {
  const carouselRef = useRef();

  return (
    <AppContainer title="Overnight Guest Report">
      <ViewReportDatePicker
        url={"overnight-guest"}
        request={{ getReportByDate, getDatesOfReports }}
      />
      <OvernighGuestContext>
        <Carousel ref={carouselRef} infinite={false}>
          {sections.map((props, index) => (
            <>
              <FormSectionContainer key={index} {...props} />
              <CarouselButtons carouselRef={carouselRef} />
            </>
          ))}
        </Carousel>
      </OvernighGuestContext>
    </AppContainer>
  );
};

export default OvernightGuestViewPage;
